import { cloneElement, useCallback } from 'react';

import Modal from '@/components/Modal/Modal';
import ExportModal from '@/features/Commons/ExportModal/ExportModal';
import useModalState from '@/hooks/pure/useModalState';
import useExportStore from '@/stores/ExportStore';
import { toast } from '@/stores/pure/ToastStore';
import useWorkspaceStore from '@/stores/WorkspaceStore';

type Props = {
  children: React.ReactElement;
  onExportClick: (reason?: string, password?: string) => void;
};

export const FeedbackExport = (props: Props) => {
  const setExportStoreState = useExportStore((state) => state.setState);
  const currWorkspace = useWorkspaceStore((state) => state.currWorkspace);

  const exportModalState = useModalState();

  const requestExport = useCallback(
    async (reason?: string, password?: string) => {
      try {
        await props.onExportClick(reason, password);
        toast('Feedback export requested', 'success');
        setExportStoreState({
          exporting: true,
        });
      } catch (error) {
        console.error(error);
        toast('Failed to export feedback', 'fail');
      }
    },
    [props, setExportStoreState],
  );

  const onExportModalConfirm = (reason: string, password: string) => {
    requestExport(reason, password);
  };

  const onExportTriggerClick = () => {
    if (currWorkspace?.password_protection) {
      exportModalState.open();
    } else {
      requestExport();
    }
  };

  const clonedChildren = cloneElement(props.children, {
    onClick: onExportTriggerClick,
  });

  return (
    <>
      {clonedChildren}
      <Modal
        status={exportModalState.status}
        closeModal={exportModalState.close}
        // Dropdown 위에 렌더링되어야 하는 케이스가 있어서 preview-layer 사용
        layerId="preview-layer"
      >
        <ExportModal onExportClick={onExportModalConfirm} />
      </Modal>
    </>
  );
};
